import {
  UserManagementUserListPage,
  UserManagementUserDetailPage,
  UserManagementPermissionDetailPage,
  UserManagementPermissionListPage,
  UserManagementRoleDetailPage,
  UserManagementRoleListPage,
} from "@Elements";
import { DashboardBaseRoute } from "./Dashboard.route";
import { createRoute, redirect } from "@tanstack/react-router";

export const UserManagementBaseRoute = createRoute({
  getParentRoute: () => DashboardBaseRoute,
  path: "/user-management",
  staticData: {
    TITLE: "Kullanıcı Yönetimi",
    IS_BASE_ROUTE: true,
  },
  beforeLoad: (route) => {
    if (route.location.pathname === UserManagementBaseRoute.fullPath)
      throw redirect({
        to: UserManagementUserListRoute.fullPath,
      });
  },
});

export const UserManagementUserBaseRoute = createRoute({
  getParentRoute: () => UserManagementBaseRoute,
  path: "/user",
  beforeLoad: (route) => {
    if (route.location.pathname === UserManagementUserBaseRoute.fullPath)
      throw redirect({
        to: UserManagementUserListRoute.fullPath,
      });
  },
});

export const UserManagementUserListRoute = createRoute({
  getParentRoute: () => UserManagementUserBaseRoute,
  path: "/list",
  component: UserManagementUserListPage,
  staticData: {
    TITLE: "Kullanıcı Listesi",
  },
});

export const UserManagementUserAddRoute = createRoute({
  getParentRoute: () => UserManagementUserBaseRoute,
  path: "/add",
  component: UserManagementUserDetailPage,
  staticData: {
    TITLE: "Kullanıcı Ekle",
    PARENT_ROUTE: UserManagementUserListRoute,
  },
});

export const UserManagementUserEditRoute = createRoute({
  getParentRoute: () => UserManagementUserBaseRoute,
  path: "/edit/$id",
  component: UserManagementUserDetailPage,
  staticData: {
    TITLE: "Kullanıcı Düzenle",
    PARENT_ROUTE: UserManagementUserListRoute,
  },
});

export const UserManagementRoleBaseRoute = createRoute({
  getParentRoute: () => UserManagementBaseRoute,
  path: "/role",
  beforeLoad: (route) => {
    if (route.location.pathname === UserManagementRoleBaseRoute.fullPath)
      throw redirect({
        to: UserManagementRoleListRoute.fullPath,
      });
  },
});

export const UserManagementRoleListRoute = createRoute({
  getParentRoute: () => UserManagementRoleBaseRoute,
  path: "/list",
  component: UserManagementRoleListPage,
  staticData: {
    TITLE: "Rol Listesi",
  },
});

export const UserManagementRoleAddRoute = createRoute({
  getParentRoute: () => UserManagementRoleBaseRoute,
  path: "/add",
  component: UserManagementRoleDetailPage,
  staticData: {
    TITLE: "Rol Ekle",
    PARENT_ROUTE: UserManagementRoleListRoute,
  },
});

export const UserManagementRoleEditRoute = createRoute({
  getParentRoute: () => UserManagementRoleBaseRoute,
  path: "/edit/$id",
  component: UserManagementRoleDetailPage,
  staticData: {
    TITLE: "Rol Düzenle",
    PARENT_ROUTE: UserManagementRoleListRoute,
  },
});

export const UserManagementPermissionBaseRoute = createRoute({
  getParentRoute: () => UserManagementBaseRoute,
  path: "/permission",
  beforeLoad: (route) => {
    if (route.location.pathname === UserManagementPermissionBaseRoute.fullPath)
      throw redirect({
        to: UserManagementPermissionListRoute.fullPath,
      });
  },
});

export const UserManagementPermissionListRoute = createRoute({
  getParentRoute: () => UserManagementPermissionBaseRoute,
  path: "/list",
  component: UserManagementPermissionListPage,
  staticData: {
    TITLE: "Yetki Listesi",
  },
});

export const UserManagementPermissionEditRoute = createRoute({
  getParentRoute: () => UserManagementPermissionBaseRoute,
  path: "/edit/$id",
  component: UserManagementPermissionDetailPage,
  staticData: {
    TITLE: "Yetki Düzenle",
    PARENT_ROUTE: UserManagementUserListRoute,
  },
});

export const SupportRouteTree = UserManagementBaseRoute.addChildren([
  UserManagementUserBaseRoute.addChildren([
    UserManagementUserListRoute,
    UserManagementUserAddRoute,
    UserManagementUserEditRoute,
  ]),
  UserManagementRoleBaseRoute.addChildren([
    UserManagementRoleListRoute,
    UserManagementRoleAddRoute,
    UserManagementRoleEditRoute,
  ]),
  UserManagementPermissionBaseRoute.addChildren([
    UserManagementPermissionListRoute,
    UserManagementPermissionEditRoute,
  ]),
]);
